<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { tooltipProps } from './tooltip'

defineOptions({
  name: 'VsTooltip',
})

const props = defineProps(tooltipProps)

// init here
</script>
